import { render, staticRenderFns } from "./detailInformationCorporate.vue?vue&type=template&id=6482c8f8&"
import script from "./detailInformationCorporate.vue?vue&type=script&lang=js&"
export * from "./detailInformationCorporate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports